import React, { useEffect, useState } from 'react';

// Antd
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined
} from '@ant-design/icons';
import { Button, Space, Spin, Table, Tag, notification } from 'antd';

// API
import { getAllCenters, deleteCenter } from '../../../Constants/Api/functions/function';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Styles
import './style.scss';
import AddCenter from './AddCenter'

const Centers = () => {
    const [tableData, setTableData] = useState([]);
    const [isAddCenterOpen, setIsAddCenterOpen] = useState(false);
    const [centers, setCenters] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [editingCenter, setEditingCenter] = useState(null)
    const dispatch = useDispatch();
    const userProfile = useSelector(state => state.userProfile.userProfile);

    useEffect(() => {
        if (userProfile?.role !== 'superadmin') {
            // history.push('/dashboard/home')
        }
    }, [userProfile])

    useEffect(() => {
        handleGetAllCenters()
    }, [])

    useEffect(() => {
        if (centers && centers.length > 0) {
            const data = centers.map((center) => {
                return {
                    key: center?.CenterId,
                    centerId: center?.CenterId,
                    centerName: center?.CenterName,
                    centerAddress: center?.CenterAddress,
                    email: center?.Email,
                    website: center?.Website,
                    fbLink: center?.FBLink,
                    phoneNumber: center?.PhoneNumber,
                    contactPerson: center?.ContactPerson,
                    createdAt: center?.CreatedAt,
                }
            })
            setTableData(data)
        } else if (centers && centers.length === 0) {
            setTableData([])
        }
    }, [centers])

    const handleGetAllCenters = async () => {
        setIsLoading(true)
        try {
            const response = await getAllCenters();
            // getAllCenters() already returns response.data (the array), not the full response object
            if (response && Array.isArray(response)) {
                // Create a new array reference to ensure React detects the change
                setCenters([...response])
            } else if (response && response.data && Array.isArray(response.data)) {
                // Fallback in case the response structure is different
                setCenters([...response.data])
            } else {
                setCenters([])
            }
        } catch (error) {
            console.error('getAllCenters', error);
            setCenters([])
        } finally {
            setIsLoading(false)
        }
    }

    const handleDeleteCenter = async (centerId) => {
        try {
            setIsLoading(true);
            const response = await deleteCenter(centerId);
            if (response?.status === 200) {
                notification.success({
                    message: 'Center Deleted',
                    description: 'Center has been deleted successfully.',
                });
                await handleGetAllCenters();
            } else {
                throw new Error('Delete failed');
            }
        } catch (error) {
            console.error('deleteCenter', error);
            notification.error({
                message: 'Error Deleting Center',
                description: 'There was an error deleting the center. Please try again.',
            });
        } finally {
            setIsLoading(false);
        }
    }


    const columns = [
        {
            title: 'Center Name',
            dataIndex: 'centerName',
            key: 'centerName',
            width: 200,
        },
        {
            title: 'Address',
            dataIndex: 'centerAddress',
            key: 'centerAddress',
            width: 200,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: 150,
        },
        {
            title: 'Phone Number',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            width: 150,
        },
        {
            title: 'Contact Person',
            dataIndex: 'contactPerson',
            key: 'contactPerson',
            width: 150,
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 150,
            render: (text, record) => (
                <Space size="middle">
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => {
                            setEditingCenter(record);
                            setIsAddCenterOpen(true);
                        }}
                    >
                        Edit
                    </Button>
                    <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => {
                            if (window.confirm('Are you sure you want to delete this center?')) {
                                handleDeleteCenter(record.centerId);
                            }
                        }}
                    >
                        Delete
                    </Button>
                </Space>
            ),
        },
    ];

    return <div className='centers'>
        <div className='centers-action-buttons'>
            <h2>
                Centers List <Tag
                    style={{
                        transform: 'translateY(-3px)',
                        marginLeft: '10px'
                    }}
                    color="blue">{tableData?.length}</Tag>
            </h2>
            {userProfile?.role === 'superadmin' &&
                <div className='actions'>
                    <Button
                        type='primary'
                        onClick={() => {
                            setEditingCenter(null);
                            setIsAddCenterOpen(true);
                        }}
                    >
                        <PlusOutlined />
                        Add Center
                    </Button>
                </div>}
        </div>
        <Spin
            spinning={isLoading}
            tip="Loading Centers..."
        >
            <Table
                className='centers_table'
                columns={columns}
                dataSource={tableData}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showQuickJumper: false,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} centers`,
                }}
                scroll={{ x: 800 }}
            />
        </Spin>
        <AddCenter
            isOpen={isAddCenterOpen}
            setOpen={setIsAddCenterOpen}
            handleGetAllCenters={handleGetAllCenters}
            editingCenter={editingCenter}
        />
    </div>;
};
export default Centers;